import { render, staticRenderFns } from "./CompanyInfoEdit.vue?vue&type=template&id=28cc7853&scoped=true&"
import script from "./CompanyInfoEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfoEdit.vue?vue&type=style&index=0&id=28cc7853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc7853",
  null
  
)

export default component.exports